class CartLink extends HTMLElement {
  constructor() {
    super();

    this.itemsCount = this.querySelector('items-count');
    this.cartCountBubble = this.querySelector('.cart-count-bubble');
  }

  connectedCallback() {
    this.unsubscribe = window.theme.cart.store.subscribe((state) => {
      const itemCount = state.products.items.reduce((total, item) => {
        const isBundleParent =
          item.properties && item.properties._configured_bundle_id;
        const isBundleComponent =
          item.properties && item.properties._bundle_component;
          
        if (isBundleParent || !isBundleComponent) {
          return total + item.quantity;
        }

        return total;
      }, 0);

      this.itemsCount.innerHTML = itemCount;

      if (this.cartCountBubble) {
        this.cartCountBubble.setAttribute('data-item-count', itemCount);
      }
    });
  }

  disconnectedCallback() {
    this.unsubscribe();
  }
}
customElements.define('cart-link', CartLink);
